import React, { Component, Fragment } from "react";
import { Survey } from "survey-react-ui";
import { Model, surveyLocalization, settings } from "survey-core";
import medicalSurveyJs from "./MedicalSurveyJs.json";
import SessionStoreManager from "../utilities/SessionStoreManager";
import Constants from "../utilities/Constants";
import Spinner from "react-bootstrap/Spinner";
import {
	endpoints,
	httpPOST,
	httpGET,
	httpDELETE,
	acceptedFileTypes,
	pdfEndpointUrl,
} from "../../api";
import { scroller } from "react-scroll";
import Auth from "../../Auth";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { DoubleBorderLight } from "survey-core/themes";
import 'survey-core/survey-core.min.css';
import '../../styles/MedicalExpensesForm.css';
import '../survey-file-preview/FilePreviewComponent';
settings.showMaxLengthIndicator = false;

/**

 * This component renders a questionnaire (using the Survey js component) for the given customer along with any previously recorded responses.

 * The user can save at any pont and submit their completed survey after they have completed all mandatory questions.

 * @returns {jsx} the survey component or a loading message

 */
class MedicalExpensesForm extends Component {
	model;
	constructor(props) {
		super(props);
		this.state = {
			questionnaire: this.props.medicalExpensesProcess.questionnaireJson,
			isLoading: false,
			responses: this.props.medicalExpensesProcess.responsesJson,
			medicalExpensesProcess: this.props.medicalExpensesProcess,
			isSaving: false,
			isSubmitting: false,
			hasSubmitted: false,
			isCompleted: this.props.medicalExpensesProcess.isCompleted,
			surveyStarted: this.props.medicalExpensesProcess.surveyStarted,
			status: this.props.medicalExpensesProcess.status,
			completedDate: this.props.medicalExpensesProcess.completedDate,
			isUploading: false,
			sectionNavHeaderClassName: "sectionNavHeader_collapsed",
			showOnCompleteMessage:false,
		};
		this.onValueChanged = this.onValueChanged.bind(this);
		this.onComplete = this.onComplete.bind(this);
		this.onCompleting = this.onCompleting.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.saveInterval = this.saveInterval.bind(this);
		this.onPartialSend = this.onPartialSend.bind(this);
		this.onUploadFiles = this.onUploadFiles.bind(this);
		this.onClearFiles = this.onClearFiles.bind(this);
		this.surveyValidateQuestion = this.surveyValidateQuestion.bind(this);
		this.handleScroll = this.handleScroll.bind(this);
	}

	componentDidMount() {
		this.renderMySurvey();
		var intervalId = setInterval(this.saveInterval, 20000);
		this.setState({ intervalId: intervalId });
		window.addEventListener("scroll", this.handleScroll);
	}

	componentWillUnmount() {
		clearInterval(this.state.intervalId);
		window.removeEventListener("scroll", this.handleScroll);
	}

	addPreviousHighlightClass = (reference) => {
		document.getElementById(reference).classList.add("scrollHighlightDiv");
		document
			.getElementById(reference)
			.getElementsByTagName("a")[0]
			.classList.add("scrollHighlightText");
	};

	removePreviousHighlightClass = () => {
		var previouslyHighlightedDiv =
			document.getElementsByClassName("scrollHighlightDiv");
		if (previouslyHighlightedDiv.length > 0)
			previouslyHighlightedDiv[0].classList.remove("scrollHighlightDiv");

		var previouslyHighlightedText = document.getElementsByClassName(
			"scrollHighlightText"
		);
		if (previouslyHighlightedText.length > 0)
			previouslyHighlightedText[0].classList.remove(
				"scrollHighlightText"
			);
	};

	scrollTo(element) {
		scroller.scrollTo(element, {
			duration: 100,
			delay: 0,
			smooth: true,
			offset: -300,
		});
		this.setState({
			sectionNavHeaderClassName: "sectionNavHeader_collapsed",
		});
	}

	removeScrollHighlightElements() {
		var previouslyHighlightedDiv =
			document.getElementsByClassName("scrollHighlightDiv");
		if (previouslyHighlightedDiv.length > 0) {
			Array.from(
				document.querySelectorAll(".scrollHighlightDiv")
			).forEach((el) => el.classList.remove("scrollHighlightDiv"));
		}
		var previouslyHighlightedText = document.getElementsByClassName(
			"scrollHighlightText"
		);
		if (previouslyHighlightedText.length > 0) {
			Array.from(
				document.querySelectorAll(".scrollHighlightText")
			).forEach((el) => el.classList.remove("scrollHighlightText"));
		}
	}

	addScrollHighlightClass(element) {
		document.getElementById(element).classList.add("scrollHighlightDiv");
		document
			.getElementById(element)
			.getElementsByTagName("a")[0]
			.classList.add("scrollHighlightText");
	}

	handleScroll(element) {
		var offset = window.pageYOffset;
		this.removeScrollHighlightElements();
		switch (true) {
			// Personal details
			case offset <= document.getElementById("motor").offsetTop - 500:
				this.addScrollHighlightClass("personalNav");
				break;
			// Motor expenses
			case offset > document.getElementById("motor").offsetTop - 500 &&
				offset <= document.getElementById("employee").offsetTop - 500:
				this.addScrollHighlightClass("motorNav");
				break;
			// Employee details
			case offset > document.getElementById("employee").offsetTop - 500 &&
				offset <= document.getElementById("practice").offsetTop - 500:
				this.addScrollHighlightClass("employeeNav");
				break;
			// Practice use of home
			case offset > document.getElementById("practice").offsetTop - 500 &&
				offset <=
					document.getElementById("subscriptions").offsetTop - 500:
				this.addScrollHighlightClass("practiceNav");
				break;
			// Subscriptions
			case offset >
				document.getElementById("subscriptions").offsetTop - 500 &&
				offset <= document.getElementById("admin").offsetTop - 500:
				this.addScrollHighlightClass("subscriptionsNav");
				break;
			// Administration expenses
			case offset > document.getElementById("admin").offsetTop - 500 &&
				offset <= document.getElementById("travel").offsetTop - 500:
				this.addScrollHighlightClass("adminNav");
				break;
			// Travel and subsistence
			case offset > document.getElementById("travel").offsetTop - 500 &&
				offset <= document.getElementById("legal").offsetTop - 500:
				this.addScrollHighlightClass("travelNav");
				break;
			// Legal and professional fees
			case offset > document.getElementById("legal").offsetTop - 500 &&
				offset <= document.getElementById("other").offsetTop - 500:
				this.addScrollHighlightClass("legalNav");
				break;
			// Other expenses
			case offset > document.getElementById("other").offsetTop - 500 &&
				offset <= document.getElementById("capital").offsetTop - 500:
				this.addScrollHighlightClass("otherNav");
				break;
			// Capital expenditure
			case offset > document.getElementById("capital").offsetTop - 500 &&
				offset <= document.getElementById("supporting").offsetTop - 500:
				this.addScrollHighlightClass("capitalNav");
				break;
			// Supporting documents
			case offset > document.getElementById("supporting").offsetTop - 500:
				this.addScrollHighlightClass("supportingNav");
				break;
		}
	}

	onValueChanged(survey, _options) {
		this.setState({
			responses: survey.data,
		});
	}

	onCompleting(survey, _options){
		_options.allowComplete=false;
		this.setState({showOnCompleteMessage:true});
	}

	surveyValidateQuestion(s, options) {
		//to do: check for decimals
		if (options.name.includes("Percentage")) {
			var entry = options.value;
			if (entry > 100) {
				options.error = "Value above 100%";
			}
		}
	}

	saveInterval() {
		try {
			if (this.state.isCompleted === false) {
				this.upsertResponses(false);
			}
		} catch (error) {
			alert("Error saving response");
		}
	}

	onPartialSend(event) {
		this.setState({
			isSaving: true,
		});

		try {
			this.upsertResponses(false);
			this.setState({
				isSaving: false,
			});
		} catch (error) {
			this.setState({
				isSaving: false,
			});
			alert("Error saving survey: " + error.value);
		}
	}

	fileTypeValidation(file) {
		if (!file || !file.name) {
			return false;
		}
		var validExts = acceptedFileTypes;
		var extension = file.name.split(".").pop().toLowerCase();

		if (validExts.includes(extension)) {
			return true;
		} else {
			var type = file.type;
			if (type.includes("image") || type === "text/plain") {
				return true;
			} else {
				return false;
			}
		}
	}

	async getExistingBlobs(auth) {
		var currentUser = SessionStoreManager.getValueByKey(
			Constants.currentUserCosmosDBKey
		);

		var parameters =
			currentUser.id +
			"/" +
			this.state.medicalExpensesProcess.id +
			"/" +
			this.state.medicalExpensesProcess.accountingYearEndDate;

		let response = await httpGET(
			endpoints.filter(
				(endpoint) => endpoint.name === "GetMedicalAdditionalDocuments"
			)[0],
			parameters,
			await auth.getToken(),
			true
		);

		if (response && response.status === 200) {
			return response.body;
		} else {
			return null;
		}
	}

	async fileNameDuplicateValidation(file) {
		const auth = new Auth();
		var i;
		//Get blobs for this questionnaire
		var existingAttachments = await this.getExistingBlobs(auth);

		// return false;
		var duplicateFound = false;

		if (existingAttachments) {
			for (i = 0; i < existingAttachments.length; i++) {
				if (
					existingAttachments[i].FileName.split('/')[1].toLowerCase() ===
					file.toLowerCase()
				) {
					duplicateFound = true;
				}
			}
		}

		return duplicateFound;
	}

	async onUploadFiles(survey, options) {
		var duplicateFiles = false;
		this.setState({
			isUploading: true,
		});

		try {
			const auth = new Auth();
			const taxYearId = this.state.medicalExpensesProcess.taxYearId;
			const expenseProcessId = this.state.medicalExpensesProcess.id;
			var i;

			for (i = 0; i < options.files.length; i++) {
				if (!this.fileTypeValidation(options.files[i])) {
					var extension = options.files[i].name.split(".").pop();
					alert(
						"Files with the extension " +
							extension +
							" are not accepted"
					);
				} else {
					// duplicateFiles = await this.fileNameDuplicateValidation(
					// 	options.files[i].name
					// );
					// if (duplicateFiles) {
					// 	alert(
					// 		"A file with the name '" +
					// 			options.files[i].name +
					// 			"' has already been attached to this questionnaire please rename your file and try again"
					// 	);
					// } else 
					// {
						(function (file) {
							var reader = new FileReader();

							// This will be called when the file content is extracted from the File object using FileReader
							reader.addEventListener(
								"load",
								async function () {
									var blobPayload;

									blobPayload = {
										// Container name is always customer ID
										containerName:
											SessionStoreManager.getValueByKey(
												Constants.taxYearProcessKey
											).customerId,
										blobName: file.name,
										base64FileContent:
											this.result.split(",")[1],
										taxYearId: taxYearId,
										folder: expenseProcessId,
									};

									let response = await httpPOST(
										endpoints.filter(
											(endpoint) =>
												endpoint.name ===
												"UploadMedicalAttachmentToBlobContainer"
										)[0],
										await auth.getToken(),
										blobPayload,
										false
									);
									if (response && response.status === 200) {
										var callbackData = {
											file: file,
											content: response.body,
										};
										
										options.callback("success", [
											callbackData,
										]);
									}
									//Upload files to blob
								},
								false
							);

							reader.readAsDataURL(file);
						})(options.files[i]);
					//}
				}
			}
			this.setState({
				isUploading: false,
			});
		} catch (error) {
			this.setState({
				isUploading: false,
			});
		}
	}
	async onClearFiles(survey, options) {
		const auth = new Auth();
		const taxYearId = this.state.medicalExpensesProcess.taxYearId;
		const expenseProcessId = this.state.medicalExpensesProcess.id;
		var parametersAttachment = "";
		// Single file in array of files

		if (options.fileName) {
			var i;
			for (i = 0; i < options.value.length; i++) {
				if (options.value[i].name === options.fileName) {
					parametersAttachment =
						SessionStoreManager.getValueByKey(
							Constants.taxYearProcessKey
						).customerId +
						"/" +
						options.fileName +
						"/" +
						expenseProcessId;

					// console.log("parameters: " + parametersAttachment);
					let response = await httpDELETE(
						endpoints.filter(
							(endpoint) =>
								endpoint.name ===
								"DeleteMedicalAttachmentFromBlobContainer"
						)[0],
						parametersAttachment,
						await auth.getToken(),
						true
					);

					if (response && response.status === 200) {
						options.callback("success");
					}
				}
			}
		}
		// All the files in the array
		else {
			var x;
			for (x = 0; x < options.value.length; x++) {
				parametersAttachment =
					SessionStoreManager.getValueByKey(
						Constants.taxYearProcessKey
					).customerId +
					"/" +
					options.value[x].name +
					"/" +
					expenseProcessId;

				// console.log("parameters: " + parametersAttachment);
				let response = await httpDELETE(
					endpoints.filter(
						(endpoint) =>
							endpoint.name ===
							"DeleteMedicalAttachmentFromBlobContainer"
					)[0],
					parametersAttachment,
					await auth.getToken(),
					true
				);
			}
			options.callback("success");
		}
	}

	async renderMySurvey() {
		var questionnaire = {};
		const auth = new Auth();
		//Is there a saved questionnaire in the process?
		if (this.state.medicalExpensesProcess.questionnaireJson !== "") {
			questionnaire = JSON.parse(
				this.state.medicalExpensesProcess.questionnaireJson
			)
			this.setState({
				questionnaire: questionnaire,
			});
		} else {
			questionnaire = medicalSurveyJs;
			this.setState({
				questionnaire: questionnaire,
			});
		}

		//is there a response for this survey?
		if (this.state.medicalExpensesProcess.responsesJson !== "") {
			var responsesJson = JSON.parse(this.state.medicalExpensesProcess.responsesJson);
			responsesJson.qAccountingYearEndDate = new Date(
				this.state.medicalExpensesProcess.accountingYearEndDate
			).toLocaleDateString("en-GB");
			responsesJson.qPracticeName = this.state.medicalExpensesProcess.generalPracticeName;

			this.setState({
				responses: responsesJson
			})
		} else {
			var currentUser = SessionStoreManager.getValueByKey(
				Constants.currentUserCosmosDBKey
			);
			var parameters = currentUser.id + "/" + currentUser.email;
			let response = await httpGET(
				endpoints.filter(
					(endpoint) => endpoint.name === "GetCustomer"
				)[0],
				parameters,
				await auth.getToken(),
				true
			);

			let gpName = response.body.LastName;
			if (
				response &&
				response.status === 200 &&
				response.body.Title != null
			) {
				gpName = response.body.Title + " " + response.body.LastName;
			}
			var prePop = {
				qAccountingYearEndDate: new Date(
					this.state.medicalExpensesProcess.accountingYearEndDate
				).toLocaleDateString("en-GB"),
				qGPName: gpName,
				qPracticeName:
					this.state.medicalExpensesProcess.generalPracticeName,
			};
			this.setState({
				responses: prePop,
			});
		}

		if (this.state.medicalExpensesProcess.questionnaireStarted !== "") {
			this.setState({
				surveyStarted:
					this.state.medicalExpensesProcess.questionnaireStarted,
			});
		} else {
			var today = new Date();
			this.setState({
				surveyStarted: today.toISOString(),
			});
		}
		if (
			this.state.medicalExpensesProcess.status === "Open" ||
			this.state.medicalExpensesProcess.status === "Started"
		) {
			this.setState({
				isCompleted: false,
			});
		} else {
			this.setState({
				isCompleted: true,
			});
		}

		
		this.model = new Model(questionnaire);
		this.model.applyTheme(DoubleBorderLight);
		this.model.onValueChanged.add(this.onValueChanged);
		this.model.onComplete.add(this.onComplete);
		this.model.onPartialSend.add(this.onPartialSend);
		
		this.model.onUploadFiles.add(this.onUploadFiles);
		this.model.onClearFiles.add(this.onClearFiles);
		this.model.onValidateQuestion.add(this.surveyValidateQuestion);
		this.model.onCompleting.add(this.onCompleting);
		
		this.model.showProgressBar =  "off";

		var myCss = {
			matrix: {
				root: "table table-striped"
			},
			navigationButton: "button btn-lg"
		};

		this.model.showQuestionNumbers = "off";
		this.model.clearInvisibleValues = "onHidden";
		this.model.data = this.state.responses;
		this.model.css = myCss;
		
		if (this.state.isCompleted) {
			this.model.readOnly = true;
			this.model.mode = "display";
			
		} else {
			this.model.sendResultOnPageNext = true;
			this.model.completeText = "Submit Medical Expenses";
		}

		const observer = new MutationObserver((mutation, obs) => {
			const fileInput = document.querySelector("input[type='file']");
			if (fileInput) {
				if (!this.state.isCompleted) {
					fileInput.addEventListener("change", (e) => {
						const questionContainer = fileInput.closest(".sv_qstn");
						const questionName = questionContainer ? questionContainer.getAttribute("data-name") : null;

						if (!questionName) {
							console.warn("Could not determine question name!");
							return;
						}
						e.preventDefault();
						this.model.onUploadFiles.fire(this.model, {
							files: e.target.files,
							name: questionName,
							callback: () => { },
						});
					});
				} else {
					if (fileInput.hasAttribute("readonly")) {
						fileInput.removeAttribute("readonly");
						fileInput.setAttribute("disabled", "true");
					}
				}
				fileInput.classList.remove("form-control")
				obs.disconnect();
			}
		});
		observer.observe(document.body, { childList: true, subtree: true });

		this.forceUpdate();
	}

	handleSave(event) {
		this.setState({
			isSaving: true,
		});

		try {
			this.setState({
				isSaving: true,
			});
			this.upsertResponses(false);
			this.setState({
				isSaving: false,
			});
		} catch (error) {
			this.setState({
				isSaving: false,
			});
			alert("Error saving response");
		}
	}

	saveDraft() {
		this.setState({
			isSaving: true,
		});

		try {
			this.setState({
				isSaving: true,
			});
			this.upsertResponses(false);
			this.setState({
				isSaving: false,
			});
		} catch (error) {
			this.setState({
				isSaving: false,
			});
			alert("Error saving response");
		}
	}

	async onComplete(survey) {
		try {
			survey.clearInvisibleValues = true;
			survey.isCompleted = true;

			this.setState({
				responses: survey.data,
			});
			window.removeEventListener("scroll", this.handleScroll);
			document.body.style.overflow = "hidden";
			this.setState({ isSubmitting: true });
			await this.upsertResponses(true);
			await this.generatePDF();
			this.setState({
				hasSubmitted: true,
				isSubmitting: false,
			});
		} catch (error) {
			survey.isCompleted = false;
			this.setState({
				isCompleted: false,
				isSubmitting: false,
				hasSubmitted: false,
			});
			alert("Error submitting survey");
		}
	}

	/* close(prop) {
    let {backToMenu} = prop;    
    backToMenu();
  } */

	async generatePDF() {
		let response = await fetch(pdfEndpointUrl, {
			method: "POST",
			headers: {
				Accept: "application/json",
				Origin: "",
				Host: pdfEndpointUrl,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				Id: this.state.medicalExpensesProcess.id,
				TemplateName: 'MedicalExpensesTemplate'
			})
		});
	}

	async upsertResponses(isCompleted) {
		//Add latest values into the medicalExpensesProcess and upsert
		var resultsToPost = this.state.medicalExpensesProcess;
		if (isCompleted) {
			var today = new Date();
			resultsToPost.status = "Complete";
			resultsToPost.questionnaireCompleted = today.toISOString();
			resultsToPost.questionnaireJson = JSON.stringify(
				this.state.questionnaire
			);
			resultsToPost.responsesJson = JSON.stringify(this.state.responses);
			resultsToPost.questionnaireStarted = this.state.surveyStarted;
		} else {
			resultsToPost.status = "Started";
			resultsToPost.questionnaireJson = JSON.stringify(
				this.state.questionnaire
			);
			resultsToPost.responsesJson = JSON.stringify(this.state.responses);
			resultsToPost.questionnaireStarted = this.state.surveyStarted;
		}

		const auth = new Auth();

		let payload = resultsToPost;
		let response = await httpPOST(
			endpoints.filter(
				(endpoint) => endpoint.name === "UpsertMedicalExpenses"
			)[0],
			await auth.getToken(),
			payload,
			true
		);
		if (response && response.status === 200) {
			//console.log("UpsertResponse response: " + response.statusText);
			var responsedata = response.body;
			this.setState({
				isSaving: false,
				medicalExpensesProcess: responsedata,
			});
			if (isCompleted) {
				this.setState({
					isCompleted: true,
				});
				await this.sendCompletionNotification(auth, responsedata);
			}
		}
	}

	async sendCompletionNotification(auth, medicalExpensesProcess) {
		let payload = medicalExpensesProcess;
		let detailstoPost = await httpPOST(
			endpoints.filter(
				(endpoint) =>
					endpoint.name === "SendMedicalCompletionNotification"
			)[0],
			await auth.getToken(),
			payload,
			true
		);
	}

	clickHeader() {
		//  sectionNavHeaderClassName: "sectionNavHeader_collapsed"
		if (
			this.state.sectionNavHeaderClassName ===
			"sectionNavHeader_collapsed"
		) {
			this.setState({
				sectionNavHeaderClassName: "sectionNavHeader_expanded",
			});
		} else {
			this.setState({
				sectionNavHeaderClassName: "sectionNavHeader_collapsed",
			});
		}
	}

	render() {
		var navigation,
			autoSaveText,
			surveyToRender = "",
			onCompleteMessage = "";
		if (!this.state.isLoading) {
			if (!this.state.isSubmitting) {
				if (this.state.hasSubmitted) {
					surveyToRender = (
						<Fragment>
							<article className="successPage">
								<section className="successGraphic"></section>
								<section className="successMessage">
									<h2>Thank you</h2>
									<h3>Your answers have been submitted</h3>
									<a className="button" href="/medical">
										My Medical Expenses
									</a>
								</section>
							</article>
						</Fragment>
					);
				} else {
					if (this.model) {
						surveyLocalization.locales[surveyLocalization.defaultLocale].cleanCaption = "Remove all";

						if (this.state.isCompleted) {
							this.model.readOnly = true;
							this.model.mode = "display";
							
						} else {
							if(this.state.showOnCompleteMessage==true){
								onCompleteMessage=(<Modal
									size="md"
									centered
									show={true}
									aria-labelledby="example-custom-modal-styling-title"
								  >
									<Modal.Header className="onCompleteMessageHeader"><span className="">Submit Medical Expenses to your Tax manager?</span></Modal.Header>
									<Modal.Body className="onCompleteMessageModalBody">
										<ul className="onCompleteMessageBody">
											<li>
											Your changes are automatically saved, so if you are looking to exit your questionnaire, simply close the browser window.
											</li>
											<li>
											If you need to contact your tax manager, head to Your messages tab.
											</li>											
										</ul>
									</Modal.Body>
									<Modal.Footer>
										<Button
											className="button submitMedicalExpenses"
											onClick={()=>this.setState({showOnCompleteMessage:false})}
										>
											Cancel
										</Button>
										<Button 
											className="button"
											onClick={this.onComplete}>
												Approve
										</Button>										
									</Modal.Footer>
								  </Modal>);
							}

							autoSaveText = (
								<span
									className="autoSaveText"
								>
									Your changes are automatically saved
								</span>
							);

						}
						surveyToRender = (
							<Survey
								model={this.model}
							/>
						);

						navigation = (
							<section className="sectionNav">
								<header
									className={
										this.state.sectionNavHeaderClassName
									}
									onClick={() => {
										this.clickHeader();
									}}
								>
									<div className="sectionsIcon"></div>
									<h2>Questionnaire sections</h2>
								</header>
								<nav className="surveyNav">
									<div
										className="menuItem scrollHighlightDiv"
										id="personalNav"
									>
										<a
											className="scrollHighlightText"
											onClick={() =>
												this.scrollTo("personal")
											}
										>
											Personal details
										</a>
									</div>
									<div className="menuItem" id="motorNav">
										<a
											onClick={() =>
												this.scrollTo("motor")
											}
										>
											Motor expenses
										</a>
									</div>
									<div className="menuItem" id="employeeNav">
										<a
											onClick={() =>
												this.scrollTo("employee")
											}
										>
											Employee costs
										</a>
									</div>
									<div className="menuItem" id="practiceNav">
										<a
											onClick={() =>
												this.scrollTo("practice")
											}
										>
											Practice use of home
										</a>
									</div>
									<div
										className="menuItem"
										id="subscriptionsNav"
									>
										<a
											onClick={() =>
												this.scrollTo("subscriptions")
											}
										>
											Subscriptions
										</a>
									</div>
									<div className="menuItem" id="adminNav">
										<a
											onClick={() =>
												this.scrollTo("admin")
											}
										>
											Administration expenses
										</a>
									</div>
									<div className="menuItem" id="travelNav">
										<a
											onClick={() =>
												this.scrollTo("travel")
											}
										>
											Travel and subsistence
										</a>
									</div>
									<div className="menuItem" id="legalNav">
										<a
											onClick={() =>
												this.scrollTo("legal")
											}
										>
											Legal and professional fees
										</a>
									</div>
									<div className="menuItem" id="otherNav">
										<a
											onClick={() =>
												this.scrollTo("other")
											}
										>
											Other expenses
										</a>
									</div>
									<div className="menuItem" id="capitalNav">
										<a
											onClick={() =>
												this.scrollTo("capital")
											}
										>
											Capital Expenditure
										</a>
									</div>

									<div
										className="menuItem"
										id="supportingNav"
									>
										<a
											onClick={() =>
												this.scrollTo("supporting")
											}
										>
											Supporting documents
										</a>
									</div>
								</nav>
							</section>
						);
					}
				}
			} else {
				//Submitting screen
				surveyToRender = (
					<Fragment>
						<article className="successPage">
							<section className="successMessage">
								<div class="spin"></div>
								<h2>Please wait</h2>
								<h3>Your answers are being submitted...</h3>
							</section>
						</article>
					</Fragment>
				);
			}
		} else {
			surveyToRender = (
				<Fragment>
					<div className="spinnerModal">
						<Spinner animation="border" role="status">
							<span className="sr-only">Loading...</span>
						</Spinner>
					</div>
				</Fragment>
			);
		}

		return (
			<div className="medicalExpensesPage">
				{navigation}
				<section className="medicalExpensesSurvey">
					{surveyToRender} {autoSaveText} {onCompleteMessage}
				</section>
			</div>
		);
	}
}

export default MedicalExpensesForm;
